import React from 'react'
import { Button } from '@resiliatech/birdsong'
import {
  FunderGoalsEmptyStateContainer,
  ContentWrapper,
  Header,
  Subheader,
  CtaContainer,
  SampleGoalImage,
  ButtonContainer,
} from './FunderGoalsEmptyState.styled'
import SampleGoal from './assets/SampleGoal.png'
import { ADD_GOAL_DISABLED_COPY } from '../utils'

type FunderGoalsEmptyStateProps = {
  isAddGoalDisabled: boolean
  onAddGoal: () => void
}

const LEARN_MORE_KNOWLEDGE_BASE_LINK =
  'https://help.resilia.com/knowledge/what-are-collaborated-goals'

export const FunderGoalsEmptyState = ({
  isAddGoalDisabled,
  onAddGoal,
}: FunderGoalsEmptyStateProps) => (
  <FunderGoalsEmptyStateContainer>
    <ContentWrapper>
      <CtaContainer>
        <Header>Welcome to Goals</Header>
        <Subheader>
          Align with your grantees to maximize and track your collective impact.
        </Subheader>
        <ButtonContainer>
          <Button
            isDisabled={isAddGoalDisabled}
            variant='primary'
            label={isAddGoalDisabled ? ADD_GOAL_DISABLED_COPY : 'Add Goal'}
            onClick={onAddGoal}
          />
          <Button
            variant='tertiary'
            label='Learn More'
            onClick={() =>
              window.open(
                LEARN_MORE_KNOWLEDGE_BASE_LINK,
                '_blank',
                'noopener,noreferrer'
              )
            }
          />
        </ButtonContainer>
      </CtaContainer>
      <SampleGoalImage src={SampleGoal} alt='Goal Sample' />
    </ContentWrapper>
  </FunderGoalsEmptyStateContainer>
)
